import React, { useEffect, useRef, useState } from "react";
import { mediaUrl, posterUrl } from "./AdMediaGallery";

/** Inner slideshow for an ad with multiple images / videos. Calls onDone when the sequence has played once. */
export default function AdMedia({ a, active = true, onDone, onMediaShown, className = "" }) {
  const media = a.media || [];
  const [i, setI] = useState(0);
  const vidRef = useRef();
  const interval = (a.media_interval_sec || 4) * 1000;

  useEffect(() => { setI(0); }, [a.id, active]);
  const cur = media[i];
  useEffect(() => { if (active && cur) onMediaShown?.(cur.id); }, [i, active, cur?.id]); // eslint-disable-line
  const advance = () => { if (i + 1 >= media.length) { onDone?.(); setI(0); } else setI(i + 1); };

  useEffect(() => {
    if (!active || !cur || cur.kind === "video") return;
    const t = setTimeout(advance, interval); return () => clearTimeout(t);
  }, [i, active, cur, interval]); // eslint-disable-line

  useEffect(() => {
    if (!active || cur?.kind !== "video") return;
    const v = vidRef.current; if (!v) return;
    v.currentTime = 0; const p = v.play(); if (p?.catch) p.catch(() => {});
    const fallback = setTimeout(advance, ((cur.duration_sec || 30) + 2) * 1000);
    return () => clearTimeout(fallback);
  }, [i, active, cur]); // eslint-disable-line

  if (!cur) return null;
  return (
    <div className={`absolute inset-0 ${className}`} data-testid={`ad-media-player-${a.id}`}>
      {media.map((m, k) => (
        <div key={m.id} className={`absolute inset-0 transition-opacity duration-700 ${k === i ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
          {m.kind === "video"
            ? (k === i ? <video ref={vidRef} src={mediaUrl(m)} poster={posterUrl(m) || undefined} muted playsInline autoPlay preload="auto" onEnded={advance} className="h-full w-full object-cover" data-testid={`ad-video-${m.id}`} /> : (m.poster_url ? <img src={posterUrl(m)} alt="" className="h-full w-full object-cover" /> : null))
            : <img src={mediaUrl(m)} alt="" loading={k === 0 ? "eager" : "lazy"} decoding="async" className="h-full w-full object-cover" />}
        </div>
      ))}
      {media.length > 1 ? (
        <div className="absolute top-2 right-2 flex gap-1 z-10">{media.map((m, k) => <span key={m.id} className={`h-1 rounded-full transition-all ${k === i ? "w-5 bg-white" : "w-2 bg-white/50"}`} />)}</div>
      ) : null}
    </div>
  );
}
